import {LossReason} from "./../../models/LossReason";


let LossReasonsApi = {
    async get(token, companyId, params={}){
        let response = await window.axios.get('/api/loss-reasons', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data.map(l=>new LossReason(l));
    },

    async create(LossReason, token, companyId){
        let response = await window.axios.post('/api/loss-reasons', LossReason, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new LossReason(response.data);
    },
    async edit(LossReason, token, companyId){
        let response = await window.axios.put('/api/loss-reasons/'+LossReason.id, LossReason, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new LossReason(response.data);
    },
    async delete(LossReason, token, companyId){
        let response = await window.axios.delete('/api/loss-reasons/'+LossReason.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
}

export default LossReasonsApi